import { IconButton, Tooltip } from "@mui/material";
import { DarkModeOutlined, LightModeOutlined } from "@mui/icons-material";
import { useThemeMode } from "@/app/ThemeContext";

interface Props {
  /** Render in inverted colors (e.g. for dark gradients on the login page). */
  invert?: boolean;
}

export const ThemeControls = ({ invert }: Props) => {
  const { mode, toggleMode } = useThemeMode();

  const sx = invert
    ? {
        color: "#fff",
        bgcolor: "rgba(255,255,255,0.12)",
        "&:hover": { bgcolor: "rgba(255,255,255,0.22)" },
      }
    : { color: "text.primary" };

  return (
    <Tooltip title={mode === "dark" ? "Aydınlık temaya geç" : "Karanlık temaya geç"}>
      <IconButton onClick={toggleMode} sx={sx}>
        {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
      </IconButton>
    </Tooltip>
  );
};
